import { cn } from "@/lib/cn";
import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
  /** Adorno a la izquierda (ej. ícono o "$"). */
  leading?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, hint, error, leading, className, id, ...props },
  ref,
) {
  const inputId = id ?? props.name;
  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label
          htmlFor={inputId}
          className="text-sm font-medium text-ink-soft"
        >
          {label}
        </label>
      )}
      <div className="relative flex items-center">
        {leading && (
          <span className="pointer-events-none absolute left-3.5 text-ink-muted">
            {leading}
          </span>
        )}
        <input
          ref={ref}
          id={inputId}
          className={cn(
            "h-11 w-full rounded-xl border bg-surface px-3.5 text-[0.95rem] text-ink",
            "placeholder:text-ink-muted/70 transition-colors",
            "focus:border-forest focus:outline-none focus:ring-2 focus:ring-forest/20",
            leading ? "pl-9" : undefined,
            error ? "border-danger" : "border-sand-300",
            className,
          )}
          aria-invalid={!!error}
          {...props}
        />
      </div>
      {error ? (
        <p className="text-xs text-danger">{error}</p>
      ) : hint ? (
        <p className="text-xs text-ink-muted">{hint}</p>
      ) : null}
    </div>
  );
});
